import React, { useEffect } from "react";
import { useAppState } from "../../app";
import { ENV } from "@vrf/fr-vrf-core";
import { usePageNavigation } from "../use-page-navigation";
import { useTranslation } from "@vrf/fr-vrf-i18n-react";
import {
  FrVrfButton,
  FrVrfDropdownField,
  FrVrfIcon,
  FrVrfSingleLineDisplayField,
  FrVrfSingleLinkDisplayField,
} from "@vrf/fr-vrf-web-components-react";
import { FrVrfDevLoginDialog } from "@vrf/fr-vrf-web-components-react";
import { useUserDetails } from "@vrf/fr-vrf-core-react";
import { setuid } from "process";
import { logout } from "../../services/rest-resource-requester";
import { setLocale } from "@vrf/fr-vrf-core";
import { EN_US } from "../../i18n";
import { removeUserDetails } from "../../util/auth-util";

require("./HeaderContent.css");

export const HeaderContent = () => {
  const [appState, setAppState] = useAppState();
  const { isPageChanged, setPageChanged, backToPrevPage, moveToPage } =
    usePageNavigation();
  const { userDetails, setUserDetails } = useUserDetails();
  const pageTitle = appState.title;
  let app = document.getElementById("app-root");
  const MANUAL_LINK =
    "https://confluence.fastretailing.com/display/FRCP/JEDI+Console+Standard+Operation";

  const showBackButton = () => appState.breadcrumbTrail.length > 1;
  const onDrawerToggleClicked = () => {
    if (isPageChanged()) {
      app?.removeAttribute("drawer-opened");
      return false;
    }
    if (showBackButton()) {
      app?.removeAttribute("drawer-opened");
      backToPrevPage();
    }
  };

  useEffect(() => {
    setLocale(EN_US);
  }, []);

  /**
   * Flag whether Dev Login is enable or not.
   */
  const ENABLE_DEV_LOGIN = ENV("REACT_APP_ENABLE_DEV_LOGIN") === "true";

  /**
   * When Dev Login is executed.
   * @param event
   */
  const onAuthenticationSucceeded = (event: CustomEvent) => {
    const userDetails = event.detail.userDetails;
    setUserDetails({ ...userDetails });
  };

  const onLogoutClickedHandle = () => {
    if (ENABLE_DEV_LOGIN) {
      removeUserDetails();
      window.location.reload();
      return;
    }
    logout();
  };

  return (
    <>
      <vaadin-drawer-toggle
        class={showBackButton() ? "back-button" : null}
        onClick={onDrawerToggleClicked}
      />
      <div className="header-title">
        <label>{pageTitle}</label>
      </div>
      <div className="header-contents">
        <div className="header-manual header-manual-link">
          <FrVrfSingleLinkDisplayField
            labelContent=""
            content="Manual"
            onClicked={() => {
              window.open(MANUAL_LINK);
            }}
          />
        </div>
        <div className="header-user-info">
          <FrVrfIcon icon="frIcon:account-uneditabile" isButton={false} />
          <label className="header-user-id">{userDetails?.userId}</label>
        </div>
        <FrVrfButton
          content="Log out"
          size="medium"
          theme="secondary"
          onClicked={onLogoutClickedHandle}
        />
      </div>
      {ENABLE_DEV_LOGIN && (
        <FrVrfDevLoginDialog
          open={userDetails?.userId == null}
          onAuthenticationSucceeded={onAuthenticationSucceeded}
        />
      )}
    </>
  );
};
